import { Component, Input, OnInit } from '@angular/core';
import { Activity } from '../models';

@Component({
  selector: 'app-strava-sticker',
  templateUrl: './strava-sticker.component.html',
  styleUrls: ['./strava-sticker.component.scss'],
})
export class StravaStickerComponent implements OnInit {

  @Input() activity: Activity;
  @Input() isLight = false;
  @Input() mapId='stravaStickerMapId';
  constructor() { }

  ngOnInit() {}

}
